import {
    FormStepper,
    EntityFormGeneralDataSection,
    EntityFormCaracteristicasSection,
} from "base/component/form";
import {
    VertidoFormCaracteristicasFields,
    VertidoFormCensoSection,
    VertidoFormGeneralDataFields,
    VertidoFormLocationFields,
} from ".";
import Box from "@mui/material/Box";

const VertidoCreationForm = ({onSubmit, onCancel = null}) => {
    const steps = ["Datos xerais", "Características", "Censo de vertidos"];

    const stepComponents = [
        <EntityFormGeneralDataSection
            fields={<VertidoFormGeneralDataFields creation={true} />}
            location={<VertidoFormLocationFields isCreationForm={true} />}
        />,
        <EntityFormCaracteristicasSection
            fields={<VertidoFormCaracteristicasFields />}
        />,
        <VertidoFormCensoSection />,
    ];
    return (
        <Box component="form" width="100%" mt={4}>
            <FormStepper
                onSubmit={onSubmit}
                onCancel={onCancel}
                steps={steps}
                stepComponents={stepComponents}
            />
        </Box>
    );
};

export default VertidoCreationForm;
